import { Instagram, Linkedin } from "lucide-react";
import { cn } from "@/lib/utils";

interface SocialFollowProps {
  className?: string;
  variant?: "inline" | "compact";
  position?: "top-left" | "bottom-right" | "static";
}

const TikTokIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const socialLinks = [
  { icon: Instagram, href: "https://www.instagram.com/odyvoy_/", label: "Instagram", color: "hover:text-pink-500" },
  { icon: TikTokIcon, href: "https://www.tiktok.com/@odyvoy_", label: "TikTok", color: "hover:text-black dark:hover:text-white" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/odyvoy/about/?viewAsMember=true", label: "LinkedIn", color: "hover:text-blue-700" },
];

export function SocialFollow({ className, variant = "inline", position = "static" }: SocialFollowProps) {
  const getPositionClasses = () => {
    switch (position) {
      case "top-left":
        return "fixed top-4 left-4 z-40";
      case "bottom-right":
        return "fixed bottom-4 right-4 z-40";
      default:
        return "relative";
    }
  };
  
  return (
    <div className={cn(
      getPositionClasses(),
      className
    )}>
      <div className="bg-white/95 dark:bg-primary/20 backdrop-blur-sm border border-border/50 dark:border-primary/30 rounded-lg p-2 shadow-lg transition-all duration-300 hover:bg-muted/95 dark:hover:bg-primary/30 hover:shadow-xl group w-fit">
        <div className="flex items-center justify-center gap-2">
          {socialLinks.map(({ icon: Icon, href, label, color }) => (
            <a
              key={label}
              href={href}
              className={cn(
                "p-2 rounded-lg text-muted-foreground dark:text-muted-foreground hover:bg-muted dark:hover:bg-primary/40 transition-all duration-200 flex items-center justify-center",
                color
              )}
              aria-label={`Follow us on ${label}`}
              title={`Follow us on ${label}`}
            >
              <Icon className="h-5 w-5" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}